import { Chip, ChipProps } from '@mui/material';
import { UiCard } from '../../types';
import { CardImage } from '../Card/CardImage';
import { AvatarIcon, useCardLabel } from '../..';

export type CardChipProps = ChipProps<'div', { card: UiCard }>;

export function CardChip({ card, ...props }: CardChipProps) {
  const label = useCardLabel(card);

  return (
    <Chip
      {...props}
      avatar={
        <AvatarIcon
          icon={
            <CardImage
              size={16}
              color={card.cardDesign.backgroundColor}
              image={card.cardDesign.backgroundImage}
            />
          }
        />
      }
      label={label}
    />
  );
}
